import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './releaseLog.module.css';

const RELEASE_LOG_API = process.env.REACT_APP_RELEASE_LOG_API as string;
const releaseLogBaseUrl = RELEASE_LOG_API.substring(
  0,
  RELEASE_LOG_API.lastIndexOf('/') + 1,
);

function resolveImageSrc(src: string): string {
  if (
    src.startsWith('./') ||
    (!src.startsWith('http') && !src.startsWith('/'))
  ) {
    return releaseLogBaseUrl + src.replace(/^\.\//, '');
  }
  return src;
}

export default function ReleaseLog() {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch(RELEASE_LOG_API)
      .then((res) => res.text())
      .then((text) => setContent(text))
      .catch((err) => {
        console.error(err);
        setContent(`Error loading release log from ${RELEASE_LOG_API}`);
      });
  }, []);

  return (
    <div className={styles.markdown}>
      <ReactMarkdown
        components={{
          img: ({ src = '', alt = '' }) => (
            <img src={resolveImageSrc(src)} alt={alt} />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
